export const help = {
  "help.title": "Centre d'aide Suji",
  "help.subtitle": "Trouvez des réponses, des guides et obtenez l'aide dont vous avez besoin",
  "help.search_placeholder": "Rechercher dans l'aide...",
  "help.quick_actions": "Actions rapides",
  "help.browse_category": "Parcourir par catégorie",
  "help.contact_support": "Contacter le support",
  "help.get_help": "Obtenez de l'aide personnalisée",
  "help.live_chat": "Chat en direct",
  "help.immediate_assistance": "Assistance immédiate",
  "help.faq": "FAQ",
  "help.frequent_questions": "Questions fréquentes",
  "help.video_tutorials": "Tutoriels vidéo",
  "help.visual_guides": "Guides visuels",
  "help.popular_articles": "Articles populaires",
  "help.read_time": "min",
  "help.read_article": "Lire l'article",
  "help.view_all_articles": "Voir tous les articles",
  "help.need_more_help": "Besoin d'aide supplémentaire ?",
  "help.support_available": "Notre équipe support est disponible pour vous aider avec toutes vos questions"
};

export default help;
